export default __webpack_public_path__ + "static/media/logo.c1bb6a2c.jpg";